import { priceActions, service } from '..';

const endpoint = 'price';

export const priceService = {
  getPrices: lineItems => service( endpoint ).post( lineItems, 'batch' )
    .then( data => !data.data ? { type: priceActions.FAILED, lineItems } : { type: priceActions.RETRIEVED, result: data.data, lineItems } )
};